<template>
<div class="chapter">
<div class="inner_page">
<div class="chap1" id="map">
<p class="ct"><a class="xref" href="#/Text/pppthreeletter005#toc">Map</a></p>
<div class="figure">
<p class="fig"><img alt="" class="calibre3" src="Images/ppp-threeletter-map.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppthreeletter006.vue?1eacc9b5